<template>
  <div class="search_box">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <div class="searchMain">
      <div class="title">
        <h2><span class="yy">课程</span></h2>
        <p>共搜索到“<span style="color:#FABE00;">{{courseData.length}}</span>”条相关结果</p>
      </div>
      <div class="course_list">
        <div class="card-li" v-for="(item, i) in courseData" :key="i" @click="toDetails(item.id)">
          <div class="home-course-list">
            <div class="home-course-item"> <img :src="item.thumb" />
            </div>
            <div class="home-course-des">
              <h3> {{ item.title }}
              </h3>
              <div class="home-course-price">
                <div class="home-course-tags">
                  {{ item.study_num }} 人学习
                </div> <span class="price"></span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="yh_card_box">
        <el-card shadow="hover" v-for="(item, i) in yhlistData" :key="i">
          <div class="yh_content_main_box">
            <div class="user__avatar"><img :src="item.avatar_url" alt="" /></div>
            <div class="user_info">
              <h3 class="user__nickname">
                {{ item.username }}
              </h3>
              <el-button class="user__follow">未关注</el-button>
            </div>
          </div>
        </el-card>
      </div>
      <div class="pagefooter">
        <el-pagination background layout="prev, pager, next" prev-text="上一页" next-text="下一页" :total="total"
          :page-size="20" @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
        </el-pagination>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: "search",
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        yhlistData: [],
        total: 0,
        currentPage: 1,
        pageSize: 20,
        courseData: []
      }
    },
    created() {
      this.courseList()
    },
    watch: {
      "$route.query.keyVal": function() {
        this.courseList()
      }
    },
    methods: {
      toDetails(id) {
        this.$router.push({
          path: "/curriculumDetail",
          query: {
            id: id
          }
        })
      },
      courseList() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            type: '1,2,3',
            search: this.$route.query.keyVal
          }
        }).then(res => {
          console.log(res.data.data.data)
          this.courseData = res.data.data.data
        }).catch(err => {
          console.log(err)
        })
      },
      getInfo() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/user/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            "current_page": this.currentPage,
            "search": this.$route.query.keyVal
          }
        }).then(res => {
          console.log(res.data.data.data)
          this.yhlistData = res.data.data.data
          this.total = res.data.data.total
        }).catch(err => {
          console.log(err)
        })
      },
      currentChange(e) {
        console.log(e);
        this.currentPage = e
        this.getInfo()
      },
      prevClick(e) {
        console.log(e);
        this.currentPage = e
        this.getInfo()
      },
      nextClick(e) {
        console.log(e);
        this.currentPage = e
        this.getInfo()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .search_box {
    .searchMain {
      text-align: left;
      width: 1200px;
      margin: 0 auto;
      padding-top: 40px;

      .title {
        .yy {
          position: relative;
        }

        .yy:after {
          position: absolute;
          content: "";
          display: block;
          bottom: -4px;
          left: 0;
          width: 100%;
          height: 8px;
          background-color: #FABE00;
          opacity: .6;
        }

        h2 {

          margin-right: 98px;
          background-color: #fff;
          border: none;
          outline: none;
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
          font-weight: 600;
        }

        p {
          display: flex;
          margin-top: 20px;
          margin-bottom: 40px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
          font-weight: 400;
          color: #a3a8ab;
        }
      }

      .yh_card_box {
        .el-card {
          display: inline-block;
          box-sizing: border-box;
          margin-right: 20px;
          margin-bottom: 32px;
          padding: 5px 0 5px 0px;
          border-radius: 10px;
          border: 1px solid #e7e9e9;
          width: calc(100% /4.215);

          &:nth-child(4n) {
            margin-right: 0;
          }
        }

        .yh_content_main_box {
          display: flex;
          box-sizing: border-box;


          .user__avatar {
            margin-right: 8px;
            width: 56px;
            height: 56px;
            border-radius: 50%;
            overflow: hidden;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
              -o-object-fit: cover;
              object-fit: cover;
            }
          }

          .user_info {
            display: flex;
            flex-flow: column;
            justify-content: space-between;

            .user__nickname {
              display: inline-block;
              max-width: 184px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
              font-weight: 600;
              color: #18252c;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .user__follow {
              background: none;
              position: relative;
              outline: none;
              border: none;
              box-sizing: border-box;
              width: 59px;
              height: 28px;
              border-radius: 14px;
              font-size: 14px;
              font-weight: 500;
              font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
              text-align: center;
              background-color: #e6f7ee;
              color: #FABE00;

            }

            /deep/ .el-button {
              span {
                position: absolute;
                left: 8px;
                top: 8px;
              }
            }
          }
        }
      }

      .pagefooter {
        display: inline-block;
        width: 100%;
        text-align: center;
        margin: 30px 0;
        margin-bottom: 50px;

        /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: #3dc57c;
          border: 1px solid #3dc57c;
          color: #fff;
        }

        /deep/ .el-pager li {
          border-radius: 8px;
          background-color: #fff;
          border: 1px solid #eaeaea;

          &:hover {
            color: #3dc57c;
          }
        }

        /deep/ .btn-prev {
          border-radius: 8px;
          background-color: #fff;
          border: 1px solid #eaeaea;
          padding: 0 10px;
        }

        /deep/ .btn-next {
          border-radius: 8px;
          background-color: #fff;
          border: 1px solid #eaeaea;
          padding: 0 10px;
        }

      }

    }

    .card-li {
      width: 25%;
      float:left;
      margin-bottom: 25px;
      border-radius: 600px;
    }

    .home-course-list {
      width: 94%;
      margin: 10px auto 0;
    }

    .home-course-des {
      color: #000;
      width: 100%;
      background-color: white;
      text-align: left;
      padding: 15px 0 0;
      border-radius: 0 0 6px 6px;
    }

    .home-course-des h3 {
      font-size: 16px;
      max-width: 100%;
      height: 40px;
      font-weight: 700;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      overflow: hidden;
      margin-left: 15px;
    }

    .authers {
      padding: 10px;
      margin-top: 16px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      border-top: 1px solid #F0F0F0;
    }

    .authers .tea {
      width: 27px;
      height: 27px;
      border-radius: 100px;
      margin-right: 10px;
    }

    .auther span {
      margin-left: 10px;
      font-size: 12px;
      line-height: 20px;
      color: #525a67;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .home-course-price {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin: 0 15px;
    }

    .price {
      color: #ff5900;
    }

    .home-course-tags {
      color: #b1b5b9;
    }

    .home-course-item {
      width: 100%;
      background-color: #fff;
      margin: 0 auto;
      height: 180px;
    }

    .home-course-item img {
      height: 100%;
      width: 100%;
      border-radius: 6px 6px 0 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/search.vue